import { slugify } from '../utils/helpers';

class Flag {
  constructor(name, elems) {
    this.name = name;
    this.slug = slugify(name);

    this.activator    = this.slug + '-activate';
    this.activeClass  = this.slug + '-flag-active';
    this.closer       = this.slug + '-close';

    this.elems = elems;
    this.elems[this.slug] = document.getElementById(this.slug + '-flag');

    this.activators = [].slice.call(document.getElementsByClassName(this.activator));

    this.activators.map((activator, i) => {
      activator.addEventListener('click', (e) => {
        if (!activator.classList.contains('js-user-required') ||
            (activator.classList.contains('js-user-required') && MM.User.isLoggedIn())) {
          this.toggleFlag();
        } else {
          MM.Login.openFlag();
        }
      });
    });

    this.closers    = [].slice.call(document.getElementsByClassName(this.closer));

    this.closers.map((close, i) => {
      close.addEventListener('click', (e) => {
        this.closeFlag();
      });
    });
  }

  closeFlag() {
    this.elems.$site.classList.remove(this.activeClass);
    this.elems[this.slug].classList.remove('active');
  }

  openFlag() {
    this.elems.$site.classList.add(this.activeClass);
    this.elems[this.slug].classList.add('active');
  }

  toggleFlag() {
    if (this.elems.$site.classList.contains(this.activeClass)) {
      this.closeFlag();
    } else {
      this.openFlag();
    }
  }
}

export default Flag;



// WEBPACK FOOTER //
// ./app/javascript/global/flag.js